import { combineReducers, configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

import { coursePlayerReducer } from '@/pages/Courses/CoursePlayer/state';

import { authMiddleware, authReducer } from './auth';
import { coreReducer } from './core';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    // Optionally pass options listed below
    actionTransformer: (action) => {
        if (action.type === 'auth/authenticated') {
            return {
                ...action,
                token: 'REDACTED',
            };
        }
        return action;
    },
});

const reducer = combineReducers({
    auth: authReducer,
    core: coreReducer,
    coursePlayer: coursePlayerReducer,
});

export const store = configureStore({
    reducer,
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authMiddleware),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
